export default "__VITE_ASSET__CEyiiKXB__"